export const PERMISSIONS = {
  PERM_1: 'perm1',
  PERM_2: 'perm2',
};
